<template>
  <div class="field no-select">
    <label
      v-if="label"
      class="mb-2 label no-select"
      :for="name"
    >
      <h3>{{ label }}</h3>
    </label>
    <p
      v-if="hasHelpText"
      class="help-text"
      v-html="finalHelpText"
    ></p>
    <range-slider
      :id="name"
      v-model="model"
      v-bind="rangeProps"
      class="range-slider"
      :disabled="isDisabled"
      tooltip-position="bottom"
    />
  </div>
</template>

<script>
import RangeSlider from '@vueform/slider/dist/slider.vue2';
import commonProperties from './common-properties';

export default {
  name: 'Range',
  components: {
    RangeSlider,
  },
  mixins: [commonProperties],
  inheritAttrs: false,
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 10,
    },
    step: {
      type: Number,
      default: 1,
    },
    format: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      rangeProps: {
        min: this.min,
        max: this.max,
        step: this.step,
        format: {
          decimals: 0,
          ...this.format,
        },
        lazy: false, // update value while dragging
      },
    };
  },
};
</script>

<style scoped lang="scss">
h3 {
  font-weight: $lb-medium;
  font-size: $size-normal;
  line-height: 1.5;
  color: $dark;
}

.range-slider {
  --slider-connect-bg: #{$crm-blue-primary}; // barra preenchida
  --slider-handle-bg: #{$crm-blue-primary}; // cor do botão
  --slider-tooltip-bg: #{$crm-blue-primary}; // cor de fundo do tooltip
  --slider-handle-shadow: none; // remoção da sombra enquando não estiver com focus
  --slider-handle-height: 24px;
  --slider-handle-width: 24px;
  --slider-handle-border: 2px solid #{$white}; // borda do botão
  --slider-tooltip-distance: 1px; // distância do tooltip
  margin-top: 12px;
  margin-bottom: 36px;
  padding-left: 8px;
  padding-right: 8px;

  &.slider-focused {
    --slider-handle-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32); // necessário para o efeito de sombra
    --slider-handle-ring-color: #{fade-out($crm-blue-primary, 0.8)}; // sombra do botão
  }
}

.help-text {
  margin-top: 0;
  margin-bottom: 0.5em;
}
</style>
